import { favoriteTokens } from '../../tokens/components/Favorite/tokens';

export const variants = {
  white: {
    stroke: favoriteTokens.LightBorder,
    initial: favoriteTokens.LightFillInitial,
    hover: favoriteTokens.LightFillHover,
    pressed: favoriteTokens.LightFillPressed,
    selected: favoriteTokens.LightFillSelected,
    outline: favoriteTokens.OutlineColor,
    disabled: favoriteTokens.Disabled,
  },
  gold: {
    stroke: favoriteTokens.LightBorder,
    initial: favoriteTokens.LightFillInitial,
    hover: favoriteTokens.LightFillHover,
    pressed: favoriteTokens.LightFillPressed,
    selected: favoriteTokens.LightFillSelected,
    outline: favoriteTokens.OutlineColor,
    disabled: favoriteTokens.Disabled,
  },
  black: {
    stroke: favoriteTokens.DarkBorder,
    initial: favoriteTokens.DarkFillInitial,
    hover: favoriteTokens.DarkFillHover,
    pressed: favoriteTokens.DarkFillPressed,
    selected: favoriteTokens.DarkFillSelected,
    outline: favoriteTokens.DarkOutlineColor,
    disabled: favoriteTokens.DarkDisabled,
  },
  inherit: {
    stroke: 'inherit',
    initial: 'inherit',
    hover: 'inherit',
    pressed: 'inherit',
    selected: 'inherit',
    outline: favoriteTokens.OutlineColor,
    disabled: favoriteTokens.Disabled,
  },
};
